import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

// This directive targets the goa-input component's internal icon element to set an appropriate aria-label based on the input's purpose,
// ensuring that screen readers can accurately describe the input's function. It uses a retry mechanism to handle cases where the input's
// content may not be immediately available in the DOM, such as when the input is rendered conditionally or updated dynamically.
// Usage: Add the inputIconAccessibility directive to any goa-input element and provide a customAriaLabel input to enhance its accessibility
// by ensuring that the internal icon has a meaningful aria-label for screen readers.
@Directive({
  selector: '[inputIconAccessibility]',
  standalone: true,
})
export class InputIconAccessibilityDirective
  implements AfterViewInit, OnChanges
{
  @Input() customAriaLabel = '';

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.updateAriaLabel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customAriaLabel']) {
      this.updateAriaLabel();
    }
  }

  private updateAriaLabel(): void {
    setTimeout(() => {
      const host = this.el.nativeElement.querySelector('goa-input')?.shadowRoot;

      if (!host) {
        return;
      }

      const iconHost =
        host.querySelector('goa-icon[type="search"]')?.shadowRoot ??
        host.querySelector('goa-icon')?.shadowRoot;
      if (!iconHost) {
        return;
      }

      const iconElement = iconHost.querySelector('div[role="img"]');
      if (!iconElement || !this.customAriaLabel?.trim()) {
        return;
      }

      iconElement.setAttribute('aria-label', this.customAriaLabel.trim());
    }, 0);
  }
}
